import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectCourse, selectCourseAccess, selectLoaded, selectLoading } from '../selectors/course.selector';
import { courseActions } from '../actions/course.actions';

@Injectable({
    providedIn: 'root',
})
export class CourseFacade {
    private store = inject(Store);

    // rxjs
    readonly loaded$ = (id: string) => this.store.select(selectLoaded(id));
    readonly loading$ = (id: string) => this.store.select(selectLoading(id));
    readonly course$ = (id: string) => this.store.select(selectCourse(id));
    readonly courseNonNullable$ = (id: string) => this.store.select(selectCourse(id)).pipe(filter((data) => data !== null));
    readonly access$ = (id: string) => this.store.select(selectCourseAccess(id));

    // signals
    readonly loaded = (id: string) => this.store.selectSignal(selectLoaded(id));
    readonly loading = (id: string) => this.store.selectSignal(selectLoading(id));
    readonly course = (id: string) => this.store.selectSignal(selectCourse(id));
    readonly access = (id: string) => this.store.selectSignal(selectCourseAccess(id));

    getCourse = (id: string) => this.store.dispatch(courseActions.getCourse({ id }));

    clear() {
        this.store.dispatch(courseActions.clear());
    }
}
